import { Attrs, MinzeElement } from 'minze'
export interface LvcEventFestivalBadge {
  label: string
}
export class LvcEventFestivalBadge extends MinzeElement {
  attrs: Attrs = [['label', '']]
  html = () => `
    <div class="custom-festival-badge">${this.label}</div>
  `
  css = () => `
    .custom-festival-badge {
      font-size: 10px;
      font-weight: 500;
      background: #1E007D;
      border-radius: 8px;
      padding: 1px 6px;
      color: white;
      justify-self: start;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  `
}
